export default () => ({
  component: 'transactions-type-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
